import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';

import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { LanguageModule } from '@language';
import { ShActionItemComponent } from '../../../../elements/components/action-item/action-item.component';
import { ShTagListComponent } from '../../../../elements/components/tag-list/tag-list.component';
import { ShClickOutsideDirective } from '../../../../elements/directives/click-outside/click-outside.directive';
import { MakeProvider } from '../../../../helpers/base-control-value-accessor';
import { FormValue, FormValueState } from '../../../entities/form-value.entity';
import { ShFormTagListComplexBaseComponent } from '../base-complex/form-tag-list-complex-base.component';

@Component({
    standalone: true,
    selector: 'sh-form-tag-list-base',
    templateUrl: '../base-complex/form-tag-list-complex-base.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(ShFormTagListBaseComponent)],
    imports: [
        ShTagListComponent,
        ShClickOutsideDirective,
        NgTemplateOutlet,
        ShActionItemComponent,
        ReactiveFormsModule,
        NgClass,
        AsyncPipe,
        LanguageModule
    ]
})
export class ShFormTagListBaseComponent extends ShFormTagListComplexBaseComponent implements OnInit {
    constructor(
        ref: ChangeDetectorRef,
        protected formBuilder: UntypedFormBuilder
    ) {
        super(ref);
    }

    propagateChange(formValues: FormValue<string>[]): void {
        const unwrapped: string[] = formValues
            .filter(formValue => formValue.state === FormValueState.SET)
            .map(formValue => FormValue.unwrap(formValue));
        super.propagateSimpleChange(unwrapped);
    }

    writeValue(values: string[]): void {
        if (values instanceof Array === false) {
            super.writeValue([]);
            return;
        }
        const converted: FormValue<string>[] = values.map(value => FormValue.wrap(value));
        super.writeValue(converted);
    }
}
